import { getPallette } from "../utils";

export const colors = getPallette(1000);
